"use client";
import { useEffect, useRef, useState } from "react";
import SwitchpageButton from "../ui/SwitchpageButton";
import Logo from "./Logo";
import TasksRewards from "../ui/TasksRewards";

const events = [
  // { id: 1, name: "派派點數大放送", url: "/" },
  // { id: 2, name: "派派點數大放送", url: "/" },
  // { id: 3, name: "派派點數大放送", url: "/" },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const headerBar = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      ref={headerBar}
      className={` max-md:w-full max-md:rounded-none max-md:mt-0  ${
        isScrolled ? "w-full mt-0" : "mt-8 w-[80vw] rounded-full"
      }`}
    >
      <div className="flex w-[90%] h-auto justify-between items-center">
        <Logo />
        <ul className="flex gap-6 max-md:gap-4 items-center font-[500]">
          {events.length > 0 && (
            <TasksRewards events={events}>任務與獎勵</TasksRewards>
          )}
          <SwitchpageButton />
        </ul>
      </div>
    </header>
  );
}
